import { useEffect } from "react"
import JobSiteCodeImport from "../../../components/jobSites/JobSiteCodeImport"
import CwAddButton from "../../../components/construction/CwAddButton"
import CwRowActions from "../../../components/construction/CwRowActions"
import { t } from "../../../i18n"
import { displayJobCode } from "../../../utils/sageCodes"

const codes = [
  { id: 1, code: "2120", name: "Framing labor" },
  { id: 2, code: "2120.5", name: "Electrical" },
]

/**
 * Unauthenticated fixture for the job-site job-codes column.
 * /preview/job-site-codes?product=construction
 */
export default function JobSiteCodesPreview() {
  useEffect(() => {
    document.documentElement.classList.add("construction-walk")
  }, [])

  return (
    <div className="min-h-screen p-4 md:p-8 bg-secondary-extra-light">
      <div className="grid gap-4 md:grid-cols-2">
        <section className="bg-white shadow-lg rounded-2xl p-4">
          <h3 className="text-lg font-semibold">{t("jobSites.title")}</h3>
        </section>
        <section className="bg-white shadow-lg rounded-2xl p-4">
          <div className="flex items-center justify-between gap-3 mb-3">
            <h3 className="text-lg font-semibold">{t("jobCodes.title")}</h3>
            <CwAddButton label={t("jobCodes.add")} onClick={() => undefined} />
          </div>
          <JobSiteCodeImport companyId={12} jobSiteId={501} />
          <table className="w-full text-sm text-start">
            <thead>
              <tr className="bg-secondary-extra-light">
                <th className="px-3 py-2 text-start">{t("jobCodes.columnCode")}</th>
                <th className="px-3 py-2 text-start">{t("jobCodes.columnName")}</th>
                <th className="px-3 py-2 text-start">{t("common.actions")}</th>
              </tr>
            </thead>
            <tbody>
              {codes.map((code) => (
                <tr key={code.id} className="border-t border-gray-100">
                  <td className="px-3 py-2">{displayJobCode(code.code)}</td>
                  <td className="px-3 py-2">{code.name}</td>
                  <td className="px-3 py-2">
                    <CwRowActions onEdit={() => undefined} onDelete={() => undefined} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      </div>
    </div>
  )
}
